import React from "react"
import { Container } from "react-grid-system"
import styled from "styled-components"
import media from "styleguide/styles/media-queries"

interface Props {
  children: React.ReactNode
  className?: string
}

export const BlueWrapper = styled.div`
  border-radius: 16px;
  background-color: #f6fbfc;
  margin: 0 15px;

  ${media.phone`
    margin: 0 8px;
  `}
`

const ContainerWrapper = styled(Container)`
  ${media.phone`
    padding-left: 24px !important;
    padding-right: 24px !important;
  `}
`

const BlueContainer = ({ children, className }: Props) => (
  <BlueWrapper className={className}>
    <ContainerWrapper>{children}</ContainerWrapper>
  </BlueWrapper>
)

export default BlueContainer
